import { FC, PropsWithChildren, useEffect, useState } from 'react';
import hardRedirectToDashboard from 'api/utils/redirectToDashboard';
import RedirectToDashboardContext, {
  RedirectToDashboardContextValue,
} from './RedirectToDashboardContext';

const RedirectToDashboardProvider: FC<PropsWithChildren> = (props) => {
  const [isRedirectingToDashboard, setIsRedirectingToDashboard] =
    useState(false);

  const value: RedirectToDashboardContextValue = {
    isRedirectingToDashboard,
    redirectToDashboard: () => {
      setIsRedirectingToDashboard(true);
    },
  };

  useEffect(() => {
    if (isRedirectingToDashboard) hardRedirectToDashboard();
  }, [isRedirectingToDashboard]);

  return (
    <RedirectToDashboardContext.Provider value={value}>
      {props.children}
    </RedirectToDashboardContext.Provider>
  );
};

export default RedirectToDashboardProvider;
